<template>
  <div class="container">
    
    <div class="add-box" :style="{ width: width + 'px' }">
    <el-page-header @back="goBack" content="添加新商品">
    </el-page-header>
      <!-- <div class="add-box-head">
        <div style="font-size: 22px;">添加课程</div>
        <div class="el-icon-close" @click="hideMaskHandle"></div>
      </div> -->
      <el-form :model="ruleForm" :rules="rules" label-width="80px" class="demo-ruleForm">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>

        <el-form-item label="商品价格" prop="price">
          <el-input v-model="ruleForm.price"></el-input>
        </el-form-item>

        <el-form-item label="商品库存" prop="stock">
          <el-input v-model="ruleForm.stock"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category_id" >
            <el-select v-model="ruleForm.category_id" placeholder="请选择分类">
              <el-option v-for="item of goodsCategory" :key="item.id"  :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="商品封面" prop="cover">
          <label for="upload-file">点击上传封面</label>
          <input id="upload-file" class="filepath" title="" @change="changepic" accept="image/*" type="file"><br>
          <img v-if="cover.indexOf('image/') !== -1" :src="imgDomain + cover" />
        </el-form-item>


        <!-- <el-form-item label="商品图片" prop="cover">
          <label for="upload-file">点击上传图片</label>
          <input v-if="!cover" id="upload-file" class="filepath" title="" @change="changepic" accept="image/*" type="file"><br>
          <img v-if="cover.indexOf('image/') !== -1" :src="imgDomain + cover" />
        </el-form-item> -->

        <el-form-item label="商品详情" prop="desc">
          <div style="border: 1px solid #ccc;" class="editor-box">
              <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
              />
              <Editor
                  style="height: 700px; width: 600px; overflow-y: hidden;"
                  v-model="html"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                  @onChange="onChange"
              />
          </div>
        </el-form-item>
        <div class="submit-box">
          <el-button type="primary" @click="submit">完成</el-button>
        </div>
      </el-form>

      <el-dialog title="裁剪封面" class="cropper-dialog" :visible.sync="showMask">
        <div class="cropper-box">
          <vue-cropper
            ref="cropper"
            class="vue-cropper"
            autoCrop
            canMoveBox
            canMove
            fixed
            centerBox
            :fixedNumber="[1, 1]"
            :img="cover"
          ></vue-cropper>
          <div class="cropper-submit-box">
            <el-button type="primary" @click="cropper">完成</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config1 from '@/config'
import { VueCropper }  from 'vue-cropper'
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { imgDomain } from '@/config'
import { mapState } from 'vuex'

export default {
  name: 'AdminList',
  data () {
    return {
      imgDomain,
      admins: [],
      width: window.outerWidth - 350,
      ruleForm: {
        name: '',
        stock: '',
        cover: '',
        detail: '',
        price: '',
        category_id: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
        ],
        course_type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        cover: [{
          required: true
        }],
        desc: [{
          required: true
        }],
        age: [{
          required: true
        }],
        stock: [{
          required: true, message: '请输入商品库存', trigger: 'blur'
        }],
        price: [{
          required: true, message: '请输入商品价格', trigger: 'blur'
        }],
        category_id: [{
          required: true, message: '请选择商品分类', trigger: 'blur'
        }]
      },
      id: 0,
      user: {},
      options: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],
      dialogCropperVisible: false,
      cover: '',
      showMask: false,
      descList: [],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      editor: null,
      html: '',
      toolbarConfig: { },
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default', // or 'simple'
    }
  },


  props: {
    msg: String
  },

  computed: {
    ...mapState([
      'series', 'goodsCategory'
    ])
  },

  components: {
    VueCropper,
    Editor,
    Toolbar
  },

  methods: {
    changepic (e) {
      console.log(e.target.files[0])
      this.cover = URL.createObjectURL(e.target.files[0])
      this.showMask = true
    },

    onCreated(editor) {
      const editor1 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      this.editor = editor1
    },

    onChange (editor) {
      console.log(editor.getHtml())
    },

    goBack () {
      this.$router.back()
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }

      this.inputVisible = false
      this.inputValue = ''
    },

    handleRemove(file) {
      console.log(file)
      this.fileList = []
    },

    handleDescRemove (file) {
     this.descList = this.descList.filter(item => item.uid !== file.uid)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(this.fileList)
    },

    handleDownload(file) {
      console.log(file);
    },

    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
      this.cover = this.fileList[0].url
      console.log(this.cover, 'ttt')
      this.showMask = true
    },

    handleDescChange(file, fileList) {
      this.descList = fileList
      console.log(this.descList, file)
      this.uploadDesc(file.raw, file.uid)
    },

    cropper () {
      this.$refs.cropper.getCropData(data => {
        console.log(this.fileList[0])
        this.uploadCover(this.dataURLtoFile(data, 'jpg'))
        this.showMask = false
      })
    },

    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime })
    },

    async uploadCover (file) {
      const json = await api.upload(file)
      const cover = json.data
      console.log(json)
      if (cover) {
        this.cover = cover
      }
    },

    async uploadDesc (file, uid) {
      const json = await api.upload(file)
      const desc = json.data
      console.log(desc, uid)
      const list = this.descList
      list.forEach((item) => {
        if (item.uid === uid) {
          item.path = desc
        }
      })

      this.descList = list
    },

    hideMaskHandle () {
      this.showMask = false
      this.user = {}
    },

    showMaskHandle () {
      this.showMask = true
    },

    handleClick (row) {
      console.log(row)
      this.showMaskHandle()
      this.user = row
    },

    async getGoodsInfo (id) {
      const json = await api.getGoodsInfo(id)
      if (json.ret !== 1000) {
        this.$message({
          message: '出错了，请刷新重试',
          type: 'error'
        })
        return
      }
      const info = json.data || {}
      this.ruleForm = info
      this.cover = info.cover
      this.html = info.detail
      console.log('商品信息:', info)
    },

    async editGoods (id, name, cover, images, video, price, detail, category_id, stock) {
      const json = await api.editGoods(id, name, cover, images, video, price, detail, category_id, stock)
      if (json.ret !== 1000) {
        this.$message({
          message: '出错了，请刷新重试',
          type: 'error'
        })
        return
      }

      location.href = '/xshop/goods_list'
    },

    async submit () {
      console.log(this.cover, this.ruleForm, this.html, this.descList)
    
      if (!this.cover || !this.ruleForm.name || !this.ruleForm.stock || !this.ruleForm.price || !this.ruleForm.category_id) {
        this.$message({
          message: '请填写必填的信息',
          type: 'warning'
        })
        return
      }

      // 修改
      if (this.id) {
        this.editGoods(this.id, this.ruleForm.name, this.cover, this.images, this.video, this.ruleForm.price, this.html, this.ruleForm.category_id, this.ruleForm.stock)
        return
      }

      // name, cover, images, video, price, detail, fees
      console.log(this.html, this.ruleForm)
      const json = await api.addGoods(this.ruleForm.name, this.cover, this.images, this.video, this.ruleForm.price, this.html, this.ruleForm.category_id, this.ruleForm.category_id)
      if (json.ret !== 1000) {
        this.$message({
          message: '出错了，请刷新重试',
          type: 'error'
        })
        return
      }

      // console.log(json)
      location.href = '/xshop/goods_list'
    }
  },

  created () {
    const id = this.$route.query.id
    // alert(id)
    if (id) {
      this.id = id
      this.getGoodsInfo(id)
    }

    const editorConfig = { MENU_CONF: {} }
    const imageConfig = {}
    const videoConfig = {}
    const config = {
      fieldName: 'file',
      timeout: 50 * 1000,
      server: `${config1.api}/upload`,
      headers: {
      },
      customInsert: (res, cb) => {
        console.log(res)
        cb(config1.imgDomain + res.data)
      },
      onError: (file, err, res) => {
        this.$notify(err, 'error')
        console.log(res)
      }
    }
    Object.assign(imageConfig, config)
    Object.assign(videoConfig, config)
    imageConfig.maxFileSize = 20 * 1024 * 1024
    videoConfig.maxFileSize = 50 * 1024 * 1024
    imageConfig.meta = {
      fileName: '富文本编辑器',
      appCode: 'system',
      pathName: 'edit/image'
    }
    videoConfig.meta = {
      fileName: '富文本编辑器',
      appCode: 'system',
      pathName: 'edit/video'
    }
    imageConfig.onError = (file, err, res) => {
      console.log(res)
      if (err.message.indexOf('maximum') > -1) this.$notify({ title: '图片超出限制，最大20M', type: 'error' })
    }
    videoConfig.onError = (file, err, res) => {
      console.log(res)
      if (err.message.indexOf('maximum') > -1) this.$notify({ title: '视频超出限制，最大50M', type: 'error' })
    }
    editorConfig.MENU_CONF['uploadImage'] = imageConfig
    editorConfig.MENU_CONF['uploadVideo'] = videoConfig
    this.editorConfig = editorConfig
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.container {
  /* margin: auto; */
  /* border: 1px solid green; */
  display: flex;
}

.add-box {
  background: #fff;
  width: 650px;
  /* height: 500px; */
  box-sizing: border-box;
  opacity: 1;
  padding: 20px;
  margin-bottom: 150px;
  text-align: left;
}

.add-box-head {
  margin: auto;
  width: 610px;
  display: flex;
  justify-content: space-between;
}

.el-form {
  margin: 30px 0;
}

.el-input {
  width: 400px;
}

.vue-cropper {
  z-index: 3;
  width: 100%;
  height: 50vh;
  margin-bottom: 20px;
}

.cropper-box {
  /* width: 300px; */
  /* height: 300px; */
  /* border: 1px solid green; */
  width: 100%;
}

.cropper-dialog {
  display: flex;
}

.cropper-submit-box {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.submit-box {
  /* border: 1px solid green; */
  text-align: center;
  margin-top: 60px;
}

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  label {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 5px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
  }

  input {
      display: block;
      margin-top: 100px;
    }
  #upload-file {
    display: none;
  }

  .editor-box {
    width: 600px;
  }
</style>
